










import Vue, { PropType } from 'vue'

import { DraggedChatElement } from './dragged-chat-element.interface'

export default Vue.extend({
  props: {
    draggedChat: {
      type: Object as PropType<DraggedChatElement | null>,
      default: null
    }
  },
  data() {
    return {
      draggingEnterCounter: 0
    }
  },
  methods: {
    dragEntered(event: DragEvent) {
      if (!this.draggedChat) return

      this.draggingEnterCounter++

      const dropzoneElement = this.$refs.dropzone as HTMLElement
      if (!dropzoneElement.style.height) {
        dropzoneElement.style.height = this.draggedChat.domElementHeight + 'px'
      }
    },
    dragLeft(event: DragEvent) {
      (this.$refs.dropzone as HTMLElement).style.height = 'auto'
      this.draggingEnterCounter--
    }
  }
})
